<template>
    <el-card class="box-card full-screen recharge-apply">
      <div ref="pageHead" class="table-page-head">
        <el-form :inline="true" :model="queryForm">
          
          <el-form-item :label="$t('checkStatus')">
            <el-select v-model="queryForm.status" :placeholder="$t('all')" size="small">
              <el-option :label="$t('all')" value=""></el-option>
              <el-option :label="$t('checkPending')" value="0"></el-option>
              <el-option :label="$t('getApproved')" value="1"></el-option>
              <el-option :label="$t('notApproved')" value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('transactionId')">
          <el-input v-model="queryForm.transactionId" size="small"></el-input>
        </el-form-item>

          <el-form-item>
            <el-button type="primary" size="small" @click="getList" :loading="isLoading"><i class="el-icon-search"></i> {{$t('query')}}</el-button>
          </el-form-item>
        </el-form>
        <el-row class="table-btns">
        <el-button type="text" size="mini" icon="el-icon-edit" @click="openAddAlert('alertCEMTIF')">{{$t('CEMTIF')}}</el-button>
        <!-- 
        <el-button type="text" v-if="loginInfo.orgType !== 2" size="mini" icon="el-icon-edit" @click="openAddAlert('alertCEMTIF')">{{$t('CEMTIF')}}</el-button>
        -->
        
      </el-row>
      </div>
  
      <div v-if="loginInfo.orgType == 1" class="data-table" :style="{top:queryTableHeight,height:`calc(100% - ${queryTableHeight} - 70px)`}">
        <el-table :data="tableData.records" v-loading="isLoading" element-loading-background="rgba(255,255,255,0.4)" size="mini" height="100%">
          
          <el-table-column prop="transactionId" fixed="left" :label="$t('transactionId')" width="200">
            <template slot-scope="scope">
              {{scope.row.transactionId}}
            </template>
          </el-table-column>
  
          <el-table-column prop="orgName" :label="$t('org')" width="150">
            <template slot-scope="scope">
              {{scope.row.orgName}}
            </template>
          </el-table-column>
          <el-table-column prop="orgInfoId" :label="$t('orgId')" width="160"></el-table-column>
          <el-table-column prop="dateTransaction" :label="$t('dateTransaction')" width="150"></el-table-column>
          <el-table-column prop="infoTransmise" :label="$t('infoTransmise')" width="160"></el-table-column>
          <el-table-column prop="objet" :label="$t('object')" width="160">
            <template slot-scope="scope">
              <div class="overstep-hidden">{{scope.row.objet}}</div>
            </template>
          </el-table-column>
          <el-table-column prop="dateTransmission" :label="$t('dateTransmission')" width="200"></el-table-column>
          <el-table-column prop="signature" :label="$t('signature')" width="160"></el-table-column>
          

          <el-table-column :label="$t('extend')" fixed="right" width="160">
            <template slot-scope="scope">
              <el-button v-if="scope.row.status==0" size="mini" @click="openCheckApply(scope.row)" type="primary">{{$t('check')}}</el-button>
              <el-button v-else size="mini" disabled>{{$t('check')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
  
      <el-pagination background layout="total,sizes,prev,pager,next,jumper" :total="tableData.total||0" :page-sizes="[20, 30, 50, 100, 200]" :page-size="pageSize" :current-page="currentPage" @size-change="setPageSzie" @current-change="setCurrentChange" @prev-click="setCurrentChange" @next-click="setCurrentChange" />
  
      <el-drawer :title="$t(applyTitle)" :visible.sync="isAddApply" :direction="'rtl'" :modal="false" :destroy-on-close="true" :wrapperClosable="false" :size="700">
      <el-form :model="applyForm" :rules="rules" ref="applyForm">

        <el-form-item :label="$t('transactionId')" prop="transactionId">
          <el-input size="medium" v-model="applyForm.transactionId"></el-input>
        </el-form-item>

        <el-form-item  :label="$t('infoTransmise')" prop="infoTransmise">
          <el-input size="medium" v-model="applyForm.infoTransmise"></el-input>
        </el-form-item>

        <el-form-item :label="$t('dateTransaction')" prop="dateTransaction">
          <el-date-picker v-model="applyForm.dateTransaction" type="datetime" :time-arrow-control="true" :format="'yyyy-MM-dd HH:mm:ss'" :placeholder="$t('selectDateAndTime')" style="width:100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('object')" prop="objet">
          <el-input type="textarea" size="medium" v-model="applyForm.objet"></el-input>
        </el-form-item>

        <div class="bottom-button">
          <el-button size="medium" type="primary" :loading="isLoading" @click="onSubmitAdd('applyForm')">{{$t('submit')}}</el-button>
        </div>
      </el-form>
    </el-drawer>

    <el-drawer :title="$t(applyTitle2)" :visible.sync="isCheckApply" :direction="'rtl'" :modal="false" :destroy-on-close="true" :wrapperClosable="false" :size="700">
      <el-form :model="checkForm" :rules="checkRules" ref="checkForm">
        <el-divider content-position="left">{{$t('applyInfo')}}</el-divider>
        <el-form-item :label="$t('transactionId')" prop="transactionId">
          <el-input size="medium" v-model="applyForm.transactionId" :value="applyForm.transactionId" disabled></el-input>
        </el-form-item>

        <el-form-item  :label="$t('infoTransmise')" prop="infoTransmise">
          <el-input size="medium" v-model="applyForm.infoTransmise" :value="applyForm.infoTransmise" disabled></el-input>
        </el-form-item>

        <el-form-item :label="$t('dateTransaction')" prop="dateTransaction">
          <el-date-picker v-model="applyForm.dateTransaction" :value="applyForm.dateTransaction" disabled style="width:100%">
          </el-date-picker>
        </el-form-item>

        <el-form-item :label="$t('object')" prop="objet">
          <el-input type="textarea" size="medium" v-model="applyForm.objet" :value="applyForm.objet" disabled></el-input>
        </el-form-item>


        <el-divider content-position="left">{{$t('checkInfo')}}</el-divider>
        <el-form-item :label="$t('checkStatus')" prop="status">
          <el-radio v-model="checkForm.status" :label="1" border>{{$t('getApproved')}}</el-radio>
          <el-radio v-model="checkForm.status" :label="2" border>{{$t('notApproved')}}</el-radio>
        </el-form-item>
        
        <div class="bottom-button">
          <el-button size="medium" type="primary" :loading="isLoading" @click="onSubmitCheckResult('checkForm')">{{$t('submit')}}</el-button>
        </div>
      </el-form>
    </el-drawer>
      
    </el-card>
  </template>
  
  <script>
  import alertCEMTIF from '@/api/alertCemtif'
  //import orgInfoApply from '@/api/orgInfoApply'
  import manba from '@/assets/uilt/manbaDate'

  export default {
    name: "alertCEMTIF",
    data () {
      return {
        isLoading: false,
        //table高度，动态设置
        queryTableHeight: String,
        //table显示内容
        tableData: {},
        //分页器默认参数
        pageSize: 20,
        currentPage: 1,
  
        queryForm: {},
        //是否显示审核申请弹框
        isCheckApply: false,
        applyTitle2: "Validation CEMTIF",
        
        
        isAddApply: false,
        applyTitle: "CEMTIF",
       
  
        //申请表单
        applyForm: {},
        //审核表单
        checkForm: {},

      }
    },
    computed: {
      rules () {
        return {
            transactionId: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
            dateTransaction: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
            objet: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
            //status: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }],
            
        }
      },
      checkRules() {
    return {
      status: [{ required: true, message: this.$t('requiredFields'), trigger: 'blur' }]
    }
  },
      loginInfo () { return this.$store.state.globalParameter.loginInfo; }
    },
    methods: {
      getList () {
        let _this = this;
        _this.isLoading = true;
        alertCEMTIF.getPage({
          param: { current: _this.currentPage, size: _this.pageSize, ..._this.queryForm },
          success: res => {
            _this.isLoading = false;
            _this.tableData = res.data || {};
          }
        })
      },
      setPageSzie (val) {
        this.pageSize = val;
        this.getList();
      },
      setCurrentChange (val) {
        this.currentPage = val;
        this.getList();
      },
      openAddAlert () {
      this.isAddApply = true; 
    },
      openCheckApply (row) {
        this.isCheckApply = true;
        this.applyForm = row;
        this.checkForm = {
            transactionId: row.transactionId,
          status: row.status,  
        }
       
      },

      /**提交充值申请 */
    onSubmitAdd (refName) {
      let _this = this;
      this.$refs[refName].validate(valid => {
        if (!valid) return false;
        _this[refName].dateTransaction = manba(_this[refName].dateTransaction).format('ymdhms')
        alertCEMTIF.addAlertCEMTIFApply({
          param: _this[refName],
          success: res => {
            _this.isLoading = false;
            if (res.code == 200) {
              _this.$message.success(_this.$t('operateSuccessfully'));
              _this.isAddApply = false;
              _this.getList();
            }
            else
              _this.$message.warning(_this.$t(res.msg));
              
          }
        })
      })

    },
  
      /**提交充值申请 */
      onSubmitCheckResult (refName) {
        let _this = this;
        this.$refs[refName].validate(valid => {
          if (!valid) return false;
          alertCEMTIF.disposeAlertCEMTIFApply({
            param: _this[refName],
            success: res => {
              _this.isLoading = false;
              if (res.code == 200) {
                _this.$message.success(_this.$t('operateSuccessfully'));
                _this.isCheckApply = false;
                _this.getList();
              }
              else
                _this.$message.warning(_this.$t(res.msg));
            }
          })
        })
      },

    },
    mounted () {
      let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
      this.queryTableHeight = queryTableHeight + 'px';

      this.getList();
    },
  }
  </script>
  
  <style lang="less" scoped>
  .recharge-apply {
    #org-info-from {
      .el-col-8 {
        margin-bottom: 31px;
      }
    }
  
    .testes {
      animation: identifier 300ms;
    }
    @keyframes identifier {
      0% {
        height: 0px;
      }
      100% {
        height: 100px;
      }
    }
  }
  </style>